"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.normalizeDataAtItem = normalizeDataAtItem;
exports.normalizeData = normalizeData;
exports.normalize = normalize;
exports["default"] = void 0;

var _getReshapedNormalizer = _interopRequireDefault(require("./getReshapedNormalizer"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
} // MUTATING FUNCTION


function normalizeDataAtItem(data, datumKey, stateKey, config) {
  var doWithNormalizedPatch = config.doWithNormalizedPatch;
  var normalizedData = [];
  data.forEach(function (datum) {
    var normalizedValue = datum[datumKey];

    if (Array.isArray(normalizedValue)) {
      normalizedValue = normalizedValue.map(function (entity) {
        return _objectSpread(_objectSpread({}, entity), {}, {
          __normalizers__: [{
            datumKey: datumKey
          }]
        });
      });
      normalizedData = normalizedData.concat(normalizedValue);
    } else if (normalizedValue) {
      normalizedValue = _objectSpread(_objectSpread({}, normalizedValue), {}, {
        __normalizers__: [{
          datumKey: datumKey
        }]
      });
      normalizedData.push(normalizedValue);
    }

    datum[datumKey] = {
      stateKey: stateKey,
      type: '__normalizer__'
    };
  });

  if (normalizedData.length) {
    if (doWithNormalizedPatch) {
      var singletonPatch = _defineProperty({}, stateKey, normalizedData);

      doWithNormalizedPatch(singletonPatch, config);
    }
  }
} // MUTATING FUNCTION


function normalizeData(data, config) {
  var globalIsMergingDatum = config.isMergingDatum,
      globalIsMutatingDatum = config.isMutatingDatum,
      normalizer = config.normalizer;
  var reshapedNormalizer = (0, _getReshapedNormalizer["default"])(normalizer);
  Object.keys(normalizer).forEach(function (datumKey) {
    var _reshapedNormalizer$d = reshapedNormalizer[datumKey],
        isMergingDatum = _reshapedNormalizer$d.isMergingDatum,
        isMutatingDatum = _reshapedNormalizer$d.isMutatingDatum,
        process = _reshapedNormalizer$d.process,
        resolve = _reshapedNormalizer$d.resolve,
        stateKey = _reshapedNormalizer$d.stateKey;
    var subNormalizer = reshapedNormalizer[datumKey].normalizer || {};
    var subConfig = Object.assign({}, config, {
      isMergingDatum: typeof isMergingDatum !== 'undefined' ? isMergingDatum : globalIsMergingDatum,
      isMutatingDatum: typeof isMutatingDatum !== 'undefined' ? isMutatingDatum : globalIsMutatingDatum,
      normalizer: _defineProperty({}, stateKey, {
        normalizer: subNormalizer,
        stateKey: stateKey
      }),
      process: process,
      resolve: resolve
    });
    normalizeDataAtItem(data, datumKey, stateKey, subConfig);
  });
} // MUTATING FUNCTION


function normalize(obj, config) {
  var normalizer = config.normalizer;

  if (normalizer) {
    var reshapedNormalizer = (0, _getReshapedNormalizer["default"])(normalizer);
    Object.keys(reshapedNormalizer).forEach(function (datumKey) {
      var data = obj[datumKey];
      var subNormalizer = reshapedNormalizer[datumKey].normalizer;

      if (!subNormalizer) {
        return;
      }

      var subConfig = Object.assign({}, config, {
        normalizer: subNormalizer
      });
      normalizeData(data, subConfig);
    });
  }
}

var _default = normalize;
exports["default"] = _default;